module.exports = __webpack_public_path__ + "static/media/Polsat_Polonia.348b6f50.png";